let checkProv = (val) => {
  let pattern = /^[1-9][0-9]/
  let provArr = [
    '11', '12', '13', '14', '15', '21', '22', '23', '31', '32', '33', '34', '35', '36', '37', '41', '42', '43', '44', '45', '46', '50', '51', '52', '53', '54', '61', '62', '63', '64', '65', '71', '81', '82']

  if (pattern.test(val)) {
    if (provArr.indexOf(val) !== -1) {
      return true
    }
  }
  return false
}

let checkDate = (val) => {
  let pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
  if (pattern.test(val)) {
    let year = val.substring(0, 4)
    let month = val.substring(4, 6)
    let date = val.substring(6, 8)
    let date2 = new Date(year + '-' + month + '-' + date)
    if (date2 && date2.getMonth() === (parseInt(month) - 1)) {
      return true
    }
  }
  return false
}

let checkCode = (val) => {
  let p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  let factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
  let parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
  let code = val.substring(17)
  if (p.test(val)) {
    let sum = 0;
    for (let i=0;i<17;i++) {
      sum += val[i]*factor[i];
    }
    console.log(sum)
    if (parity[sum % 11].toString() === code.toUpperCase()) {
      return true;
    }
  }
  return false;
}

let checkID = (val) => {
  if (checkCode(val)) {
    let date = val.substring(6, 14);
    if (checkDate(date)) {
      if (checkProv(val.substring(0, 2))) {
        return true
      }
    }
  }
  return false
}

let deleteEmptyValue = condition => {
  for (let key in condition) {
    if (condition[key] === '' || condition[key] === null) {
      delete condition[key]
    }
  }

  return condition
}

let timeRangeConvert = timeRange => {
  let startPointSeconds = timeRange[0]
  let endPointSeconds = timeRange[1] + 86399000
  return {
    'startPointMilSeconds': startPointSeconds,
    'endPointMilSeconds': endPointSeconds,
    'startPointSeconds': (startPointSeconds / 1000).toFixed(0),
    'endPointSeconds': (endPointSeconds / 1000).toFixed(0)
  }
}

const chunkArray = function (array, size) {
  let [start, end, result] = [null, null, []];
  for (let i = 0; i < Math.ceil(array.length / size); i++) {
    start = i * size
    end = start + size
    result.push(array.slice(start, end))
  }
  return result
}

const findDifferentBetweenTwoObj = (before, after) => {
  let ret = {}
  Object.keys(after).forEach(key => {
    if (after[key] !== before[key]) {
      ret[key] = after[key]
    }
  })
  return ret
}

const formatNumber = num => {
  return (num < 10 ? '0' : '') + num
}

const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}

const OrgTypeFirstPath = {COMPANY:'/today_sum_total', APARTMENT:'/manage',OPENSPACE:'/device_manage'}

export {
  checkID, deleteEmptyValue, timeRangeConvert, chunkArray, findDifferentBetweenTwoObj, formatNumber, getRandomInt, OrgTypeFirstPath
}
